/**
 * Define all variables related to enum type
 * */
enum CHECKBOX_STATUS {
  ACCEPTED = 1,
  UN_ACCEPTED = 2
}

enum GROW_TREE_TYPE {
  BODY = 1,
  HAND = 2,
  LANGUAGE = 3,
  INTERACTION = 4,
  WC = 5,
  SLEEP = 6,
  EAT = 7,
}

enum GROW_TREE_MODAL_TYPE {
  STEP = 1,
  MILESTONE = 2,
  ISLAND = 3
}

enum MEDIA_TYPE {
  VIDEO = 1,
  SALON = 2,
  LIVE = 3,
  EXTERNAL = 4
}

enum CODE_RESPONSE {
  LOGIN_ERROR = 610,
  IS_NOT_COMPLETED_TUTORIAL = 611,
  IS_COMPLETED_TUTORIAL = 612
}

enum TYPE_MEMO {
  MILESTONE_MEMO = 1,
  POINT_MEMO = 2
}

export {
  CHECKBOX_STATUS,
  GROW_TREE_TYPE,
  GROW_TREE_MODAL_TYPE,
  MEDIA_TYPE,
  CODE_RESPONSE,
  TYPE_MEMO
}
